import React, { useEffect, useState } from 'react';
import { Fade } from 'react-bootstrap';
import './ContentBlockEditor.scss';
import PropTypes from 'prop-types';

const propTypes = {
  transparent: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  title: PropTypes.string,
};
const defaultProps = {
  transparent: false,
  children: [],
  title: '',
};

export function ContentBlockEditor({ children, transparent, title }) {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <div className="content-block-editor" data-testid="Wrapper-contentBlock">
      <Fade in={fadeIn}>
        <div className="content-block-editor-overlay">
          {transparent ? (
            <div className="content-block-editor-form p-4 no-bg">
              {children}
            </div>
          ) : (
            <div className="card content-block-editor-form shadow-lg">
              <div
                className="card-header text-center p-2"
                data-testid="Text-title"
              >
                <strong>{title}</strong>
              </div>
              <div className="card-body">{children}</div>
            </div>
          )}
        </div>
      </Fade>
    </div>
  );
}

ContentBlockEditor.propTypes = propTypes;
ContentBlockEditor.defaultProps = defaultProps;
